import { useAuth } from "../contexts/AuthContext";
import { Container, Group, Title, Text, Button, Box } from "@mantine/core";
import "../Layout.css"; // ✅ import the CSS file

const Layout = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e3e9fdff, #f4eefcff)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        component="header"
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          padding: "0.75rem 0",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Container size="xl" className="header-container">
          {/* Left: Logos */}
          <Group
            spacing="xs"
            align="center"
            style={{ flex: "1 1 auto", minWidth: 0 }}
          >
            <img
              src="/assets/althing_clinic_banner.png"
              alt="Portal Banner"
              style={{
                height: 36,
                width: "auto",
                objectFit: "contain",
                maxWidth: "100%",
              }}
            />
            <span className="separator">×</span>
            <img
              src="/althing_airs_logo.png"
              alt="Second Logo"
              style={{
                height: 36,
                width: "auto",
                objectFit: "contain",
                maxWidth: "100%",
              }}
            />
          </Group>

          {/* Center: Title */}
          <Box className="title-box">
            <Title
              order={2}
              style={{
                color: "#1F2937",
                fontSize: "1.5rem",
                fontWeight: 700,
              }}
            >
              AIRs Sign Up Portal
            </Title>
          </Box>

          {/* Right: Logout & Welcome */}
          <Group
            spacing="sm"
            align="center"
            style={{
              flex: "1 1 auto",
              justifyContent: "flex-end",
              minWidth: 0,
              order: 2,
            }}
          >
            {user && (
              <Text size="sm" color="dimmed" className="welcome-text">
                Welcome, {user.username} ({user.role})
              </Text>
            )}
            <Button color="red" variant="filled" size="sm" onClick={logout}>
              Logout
            </Button>
          </Group>
        </Container>
      </Box>

      {/* Main Content */}
      <Box component="main" py="xl" style={{ flex: 1 }}>
        <Container size="xl">{children}</Container>
      </Box>
    </div>
  );
};

export default Layout;
